import { useAuthStore } from '@auth/authStore';
import { addDiagram } from '@dashboard/store/dashboardActions';
import { useOrganizationStore } from '@shared/organization/organizationStore';
import { addStatus } from '@shared/status/statusActions';

export const generateDiagram = async (requestText: string) => {
  const { getFunctionsService } =
    await import('../../../shared/services/firebaseConfig');
  const functions = await getFunctionsService();
  const { httpsCallable } = await import('firebase/functions');
  try {
    const auth = useAuthStore.getState().auth;
    if (!auth) throw new Error('User not authenticated');
    if (requestText.length === 0) {
      const diagramId = await addDiagram({
        name: 'Blank Diagram',
        description: 'Blank diagram created at: ' + new Date().toLocaleString(),
        access: 'public',
        users: {
          [auth.uid]: 'author',
        },
      });

      if (!diagramId) {
        throw new Error('Failed to create diagram - undefined ID');
      }

      return diagramId;
    }

    const generateDiagramAction = httpsCallable<
      { requestText: string; orgId: string | undefined },
      { diagramId: string }
    >(functions, 'generateDiagram');
    const orgId = useOrganizationStore.getState().organization?.id;
    const result = await generateDiagramAction({ requestText, orgId });

    const diagramId = result.data?.diagramId;

    if (!diagramId)
      throw new Error('Failed to generate diagram - undefined ID');

    return diagramId;
  } catch (error) {
    console.error('Error calling generateDiagram function:', error);
    addStatus({
      type: 'error',
      message: 'Failed to create diagram. Please try again.',
      autoDismiss: true,
    });
    throw error;
  }
};
